import { Link, useLocation } from "react-router-dom";
import { Lock, LogOut } from "lucide-react";
import { useAuth } from "@/auth";

// Page frame shared by every page: TCA logo + banner header, title, account bar, content, account bar,
// letterhead footer. From TCA-Payroll-New-Employee-Masterfile (itself from TCA-Debit-Order-Mandate).

// Shown twice (owner): at the top under the orange line and at the bottom, so the user can sign out
// or open Settings wherever they are on the page.
const AccountBar = ({ place }) => {
  const { user, signOut } = useAuth();
  const { pathname } = useLocation();
  if (!user) return null;
  return (
    <div className={`bee-account-bar bee-account-bar-${place}`} data-testid={`account-bar-${place}`}>
      <span className="bee-account-name">
        Signed in as <strong>{user.first_name} {user.last_name}</strong>
      </span>
      <div className="bee-account-actions">
        <button type="button" className="bee-signout" onClick={signOut} data-testid={`button-sign-out-${place}`}>
          <LogOut size={14} /> <span>Sign Out</span>
        </button>
        {/* Administrator only; charcoal (slate, like the Personal Tax site's Settings button) */}
        {user.role === "admin" && pathname !== "/settings" && (
          <Link to="/settings" className="bee-settings-btn" data-testid={`settings-button-${place}`}>
            <Lock size={14} /> <span>Settings</span>
          </Link>
        )}
      </div>
    </div>
  );
};

// bottom: shown just above the bottom account bar (owner, 2026-10-11: the Back button again, so the user
// can go back from the bottom of a long page too)
const PageFrame = ({ title, subtitle, children, bottom }) => (
  <div className="app-container">
    <div className="form-wrapper">
      <header className="form-header">
        <img src="/images/TCA_Logo_Header.jpeg" alt="TC Auditors Logo" className="logo" />
        <img src="/images/TCA_Banner_Header.png" alt="Tax & Auditing Consultants" className="banner" />
        <h1 className="form-title">{title}</h1>
        {subtitle && <p className="form-subtitle">{subtitle}</p>}
      </header>
      <main className="form-content">
        <AccountBar place="top" />
        {children}
        {bottom && <div className="bee-page-bottom">{bottom}</div>}
        <AccountBar place="bottom" />
        <div className="letterhead-footer-container">
          <img src="/images/letterhead-footer.png" alt="TC Auditors Footer" className="letterhead-footer" />
        </div>
      </main>
    </div>
  </div>
);

export default PageFrame;
